import { useState } from 'react';
import axios from 'axios';

export const useSSNVerification = () => {
  const [loading, setLoading] = useState(false);

  const handleSSNVerification = async (userId, ssn, onSuccess, onError) => {
    setLoading(true);
    try {
      const response = await axios.get(`/admin/invoice/ssn-verification/${userId}/${ssn}`);

      if (response?.data?.statusCode === 200 && response?.data?.response === true) {
        if (onSuccess) {
          onSuccess(response.data.message || 'SSN verified successfully');
        }
      } else {
        const errorMessage = response?.data?.message || 'Failed to verify SSN';
        if (onError) {
          onError(errorMessage);
        }
      }
    } catch (err) {
      const errorMessage = err?.response?.data?.message || err?.message || 'Failed to verify SSN';
      if (onError) {
        onError(errorMessage);
      }
    } finally {
      // Keep loading state visible for at least a brief moment
        setLoading(false);

    }
  };

  return { handleSSNVerification, loading };
};
